import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './Context/AuthContext';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './Pages/LoginPage/LoginPage';
import ProtectedRoute from './Routes/ProtectedRoute';
import LogoutPage from './Pages/LoginPage/LogoutPage';
import Home from './Pages/Home/Home';
import Header from './Components/Layouts/Header';
import AdminDashboard from './Pages/AdminPage/AdminDashboard';
import PMDashboard from './Pages/ProjectManagerPage/PMDashboard';
import TeamLeadDashboard from './Pages/TeamLead/TeamLeadDashboard';
import TMDashboard from './Pages/TeamMember/TMDashboard';
import UserProfile from './Pages/UserProfile/UserProfile';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CombinedTimesheetComponent from './Pages/UserProfile/CombinedTimesheetComponent';
import OverallLogPage from './Components/OverAllLogs/OverallLogPage';
import ClientDashboard from './Pages/Client/ClientDashboard';
import LeaveDashboard from './Pages/Leave/LeaveDashboard';
import ApplyLeave from './Pages/Leave/ApplyLeave';
import AdminLeaveHistory from './Pages/Leave/AdminLeaveHistory';
import AdminLeaveBalance from './Pages/Leave/AdminLeaveBalance';
import HolidayManagement from './Pages/AdminPage/HolidayManagement';
import AdminLeaveManageDash from './Pages/AdminPage/AdminLeaveManageDash';
import AdminLeaveSummary from './Pages/Leave/AdminLeaveSummary';

function App() {
  return (
    <>
      <AuthProvider>
        <ToastContainer position="top-right" autoClose={3000} />
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/login' element={<LoginPage />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path='/logout' element={<LogoutPage />} />
          <Route path="/Admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />

          <Route path="/Project" element={<ProtectedRoute><PMDashboard /></ProtectedRoute>} />

          <Route path="/TeamLead" element={<ProtectedRoute><TeamLeadDashboard /></ProtectedRoute>} />
          <Route path="/Member" element={<ProtectedRoute><TMDashboard /></ProtectedRoute>} />
          <Route path="/client" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
          <Route path="/WorkSheet" element={<ProtectedRoute><CombinedTimesheetComponent /></ProtectedRoute>} />
          <Route path="/OverallLog" element={<ProtectedRoute><OverallLogPage /></ProtectedRoute>} />

<Route path="/leave" element={<LeaveDashboard />} />
<Route path="/leave/apply" element={<ApplyLeave />} />
<Route path="/leave/history" element={<AdminLeaveHistory />} />

{/* Admin Leave Management */}
<Route
  path="/admin/holidays"
  element={
    <ProtectedRoute>
      <HolidayManagement />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/leave-balance"
  element={
    <ProtectedRoute>
      <AdminLeaveBalance />
    </ProtectedRoute>
  }
/>
<Route
  path="/admin/leave-manage"
  element={
    <ProtectedRoute>
      <AdminLeaveSummary />
    </ProtectedRoute>
  }
/>


        </Routes>
        {/* <Footer /> */}
      </AuthProvider>
    </>
  );
}

export default App;
